module.exports = __webpack_public_path__ + "static/media/schody31 - schody drewniane zabiegowe.6cb166ce.jpg";